export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/greenCalendar.8c2a8e77.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};